import { useState, useEffect } from 'react';
import './pages.css';

const Toggle = ({ checked, onChange }) => (
    <div onClick={onChange} style={{
        width:'44px',height:'24px',borderRadius:'12px',cursor:'pointer',
        background:checked?'#a5761e':'#cbd5e1',position:'relative',transition:'background 0.2s',flexShrink:0,
    }}>
        <div style={{
            position:'absolute',top:'3px',left:checked?'23px':'3px',
            width:'18px',height:'18px',background:'white',borderRadius:'50%',transition:'left 0.2s',
            boxShadow:'0 1px 4px rgba(0,0,0,0.2)',
        }}/>
    </div>
);



function ProfilePage() {
    const [user, setUser] = useState({ 
        name:'', email:'', phone:'', kycStatus:'', role:'', joinDate:'', 
        profilePic:null, clientId:'', address:'', dob:'', gender:'', creditScore:'', panNumber:'' 
    });
    const [editing, setEditing] = useState(false);
    const [form, setForm] = useState({});
    const [points, setPoints] = useState(0);
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState({ type:'', text:'' });
    const [modal, setModal] = useState(null);
    const [notifs, setNotifs] = useState({ email:true, sms:true, loanUpdates:true, paymentReminders:true, promos:false });
    const API_URL = process.env.REACT_APP_API_URL || '';

    useEffect(()=>{
        const s = JSON.parse(localStorage.getItem('userSession'));
        if (!s?.userId) return;
        fetch(`${API_URL}/api/auth/profile/${s.userId}`).then(r=>r.json()).then(d=>{
            if (d.success){
                const u = {
                    name:d.user.name, email:d.user.personal_email || d.user.email, phone:d.user.phone,
                    kycStatus:d.user.kycStatus||'Pending', role:d.user.role||'User',
                    joinDate:new Date(d.user.joinDate).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric', timeZone: 'Asia/Kolkata'}),
                    // Server photo (KYC selfie or a manual upload) is the source of truth.
                    // The localStorage key is only a fallback for pics saved before it was persisted.
                    profilePic:d.user.profilePhotoUrl||localStorage.getItem(`profilePic_${s.userId}`)||null,
                    clientId:d.user.clientId,
                    address:d.user.address,
                    dob:d.user.dob ? new Date(d.user.dob).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' }) : null,
                    gender:d.user.gender,
                    creditScore:d.user.creditScore,
                    panNumber:d.user.panNumber,
                };
                setUser(u); setForm(u);
            }
        }).catch(()=>{});

        // Fetch reward points
        fetch(`${API_URL}/api/dashboard/all-data/${s.userId}`)
            .then(r => r.json())
            .then(d => {
                if (d.success && d.gamification) {
                    setPoints(d.gamification.pointsBalance || 0);
                }
            })
            .catch(()=>{});
    },[API_URL]);

    const showMsg = (type, text) => { setMsg({type,text}); setTimeout(()=>setMsg({type:'',text:''}),3500); };

    const handleSave = async (e) => {
        e.preventDefault(); setSaving(true);
        const s = JSON.parse(localStorage.getItem('userSession'));
        try {
            const r = await fetch(`${API_URL}/api/auth/profile/update/${s.userId}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
            const d = await r.json();
            if (d.success){ setUser({...user,...form}); setEditing(false); showMsg('success','Profile updated successfully!'); }
            else showMsg('error', d.message || 'Failed to update profile.');
        } catch { showMsg('error','Update failed.'); } finally { setSaving(false); }
    };

    const kycColor = user.kycStatus==='completed'?'#10b981':user.kycStatus==='in_progress'?'#f59e0b':'#ef4444';
    const kycLabel = user.kycStatus==='completed'?'✅ Verified':user.kycStatus==='in_progress'?'🔄 In Progress':'⏳ Pending';

    const SETTINGS = [
        { key:'notifications',icon:'🔔',label:'Notification Preferences',desc:'Control alerts and reminders' },
    ];

    return (
        <div className="pg-root">

            <div className="pg-header">
                <div className="pg-header-text">
                    <h1>👤 My Profile</h1>
                    <p>Manage your personal information and preferences</p>
                </div>
            </div>

            {msg.text && (
                <div className={`pg-alert ${msg.type==='success'?'pg-alert-success':'pg-alert-danger'}`}>
                    <span className="pg-alert-icon">{msg.type==='success'?'✅':'⚠️'}</span>
                    <div className="pg-alert-body" style={{flex:1}}><p>{msg.text}</p></div>
                </div>
            )}

            <div className="profile-layout">
                {/* Avatar Card */}
                <div className="pg-panel profile-avatar-panel">
                    <div className="profile-avatar-wrap">
                        <div className="profile-avatar" style={{
                            width:'96px',height:'96px',borderRadius:'20px',
                            background:'linear-gradient(135deg,#a5761e,#c8952a)',
                            display:'flex',alignItems:'center',justifyContent:'center',
                            fontSize:'2.5rem',color:'white',fontWeight:'800',
                            overflow:'hidden',border:'3px solid white',boxShadow:'0 8px 20px rgba(165, 118, 30,0.25)',margin:'0 auto',
                        }}>
                            {user.profilePic ? <img src={user.profilePic} alt="avatar" style={{width:'100%',height:'100%',objectFit:'cover'}}/> : user.name?.charAt(0)||'?'}
                        </div>
                    </div>
                    <div style={{fontWeight:'800',fontSize:'1rem',color:'#1e1b4b',marginBottom:'0.15rem'}}>{user.name||'—'}</div>
                    <div style={{fontSize:'0.75rem',color:'#94a3b8',marginBottom:'0.85rem'}}>{user.role} · {user.joinDate}</div>
                    <span className="pg-badge" style={{background:`${kycColor}15`,color:kycColor,border:`1px solid ${kycColor}40`,fontSize:'0.72rem',padding:'0.3rem 0.75rem'}}>
                        {kycLabel}
                    </span>
                    <div className="profile-reward-card">
                        <div style={{fontSize:'0.65rem',fontWeight:'700',color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.5px'}}>Reward Points</div>
                        <div style={{fontSize:'1.3rem',fontWeight:'800',color:'#a5761e'}}>🌟 {points.toLocaleString()} pts</div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="profile-main">
                    {/* Personal Details */}
                    <div className="pg-panel">
                        <div className="pg-panel-header">
                            <h2>Personal Details</h2>
                            <button className="pg-btn pg-btn-secondary" style={{padding:'0.4rem 0.9rem',fontSize:'0.8rem'}} onClick={()=>{ setEditing(!editing); if(editing) setForm(user); }}>
                                {editing?'✕ Cancel':'✏️ Edit'}
                            </button>
                        </div>
                        {editing ? (
                            <form onSubmit={handleSave}>
                                <div className="pg-form">
                                    <div className="pg-field-row">
                                        <div className="pg-field">
                                            <label>Full Name {user.kycStatus === 'completed' && '(Verified)'}</label>
                                            <input type="text" name="name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required disabled={user.kycStatus === 'completed'} title={user.kycStatus === 'completed' ? 'Name cannot be changed after KYC verification' : ''} style={{ opacity: user.kycStatus === 'completed' ? 0.6 : 1, cursor: user.kycStatus === 'completed' ? 'not-allowed' : 'text' }}/>
                                        </div>
                                        <div className="pg-field">
                                            <label>Email Address *</label>
                                            <input type="email" name="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required/>
                                        </div>
                                        <div className="pg-field">
                                            <label>Phone Number (Login ID)</label>
                                            <input type="tel" name="phone" value={form.phone} disabled style={{ opacity: 0.6, cursor: 'not-allowed' }} title="Phone number cannot be changed as it is your login ID."/>
                                        </div>
                                    </div>
                                    <div style={{display:'flex',gap:'0.75rem',justifyContent:'flex-end',marginTop:'0.25rem'}}>
                                        <button type="submit" className="pg-btn pg-btn-primary" disabled={saving}>{saving?'Saving…':'Save Changes'}</button>
                                    </div>
                                </div>
                            </form>
                        ) : (
                            <div className="profile-details-grid">
                                {[['Full Name',user.name],['Email Address',user.email],['Phone Number',user.phone],['Member Since',user.joinDate]].map(([l,v])=>(
                                    <div className="profile-detail-item" key={l}>
                                        <div style={{fontSize:'0.65rem',fontWeight:'700',color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.5px',marginBottom:'0.25rem'}}>{l}</div>
                                        <div className="profile-detail-value" style={{fontSize:'0.95rem',fontWeight:'600',color:'#1e293b'}}>{v||'—'}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>


                    {/* Settings */}
                    <div className="pg-panel">
                        <div className="pg-panel-header"><h2>Account Settings</h2></div>
                        <div className="profile-settings-grid">
                            {SETTINGS.map(s=>(
                                <div className="profile-setting-card" key={s.key} onClick={()=>setModal(s.key)} style={{
                                    background:'#faf6ec',border:'1px solid #e9d9ae',borderRadius:'14px',
                                    padding:'1rem',cursor:'pointer',transition:'all 0.18s',
                                }}
                                onMouseEnter={e=>e.currentTarget.style.background='#f3e9d2'}
                                onMouseLeave={e=>e.currentTarget.style.background='#faf6ec'}>
                                    <div style={{fontSize:'1.5rem',marginBottom:'0.4rem'}}>{s.icon}</div>
                                    <div style={{fontWeight:'700',fontSize:'0.85rem',color:'#1e293b',marginBottom:'0.15rem'}}>{s.label}</div>
                                    <div style={{fontSize:'0.72rem',color:'#94a3b8'}}>{s.desc}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Notifications Modal */}
            {modal==='notifications' && (
                <div className="pg-modal-overlay" onClick={()=>setModal(null)}>
                    <div className="pg-modal" onClick={e=>e.stopPropagation()}>
                        <div className="pg-modal-header"><h2>🔔 Notification Preferences</h2><button className="pg-modal-close" onClick={()=>setModal(null)}>×</button></div>
                        <div className="pg-modal-body">
                            <div style={{display:'flex',flexDirection:'column',gap:'0'}}>
                                {[['email','Email Notifications','Receive updates via email'],
                                  ['sms','SMS Notifications','Get updates via SMS'],
                                  ['loanUpdates','Loan Updates','Loan status changes'],
                                  ['paymentReminders','Payment Reminders','Upcoming EMI alerts'],
                                  ['promos','Promotional Emails','Offers and promotions'],
                                ].map(([k,label,desc])=>(
                                    <div key={k} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'0.85rem 0',borderBottom:'1px solid #f3e9d2'}}>
                                        <div>
                                            <div style={{fontWeight:'700',fontSize:'0.88rem',color:'#1e293b'}}>{label}</div>
                                            <div style={{fontSize:'0.75rem',color:'#94a3b8'}}>{desc}</div>
                                        </div>
                                        <Toggle checked={notifs[k]} onChange={()=>setNotifs({...notifs,[k]:!notifs[k]})}/>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="pg-modal-footer">
                            <button className="pg-btn pg-btn-ghost" onClick={()=>setModal(null)}>Cancel</button>
                            <button className="pg-btn pg-btn-primary" onClick={()=>{showMsg('success','Preferences saved!');setModal(null);}}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProfilePage;
